import { observer } from 'mobx-react-lite';

import type { ITemplateNode } from '@ifs-gcp/core';
import type { LogoGalleryChild } from '@ifs-gcp/core/models';

import styles from './module-logos.module.scss';

interface LogoGalleryProps {
  element: ITemplateNode<LogoGalleryChild>;
}

export const ModuleLogos = observer(({ element: { children } }: LogoGalleryProps) => {
  return (
    <div className={styles.standardList}>
      {children.map((element) => (
        <img
          key={element.props.logoPath}
          src={`/assets/definitions/${element.props.logoPath}`}
          className={styles.logo}
          alt={`Module logo ${element.props.logoPath}`}
        />
      ))}
    </div>
  );
});
